module.exports = __webpack_public_path__ + "img/49.6.CODm.6a9c2c88.png";